import React from "react";
import {
  NewModal as Modal,
  NewTypography as Typography,
  NewBox as Box,
  NewLink as Link,
  NewButton as Button,
} from "@bca/ui-library";

import BatteryGradesTable from "./BatteryGradesTable";
import pushBatteryGradeData, {
  AnalyticsData,
} from "../../analytics/pushBatteryGradeData";

interface BatteryGradeSlideoutProps {
  isOpen: boolean;
  onClose: () => void;
  data: { condition: number | null; reportUrl: string };
  analyticsData?: AnalyticsData;
}

const BatteryGradeSlideout = ({
  isOpen,
  onClose,
  data,
  analyticsData,
}: BatteryGradeSlideoutProps) => {
  const handleViewReport = () => {
    window.open(data.reportUrl, "_blank");
    pushBatteryGradeData(
      {
        action: "view",
        category: "button",
        label: "ev-battery|report",
        name: "click",
        section: "pop-up",
        type: "pdf",
        value: "",
      },
      analyticsData
    );
  };

  const handleTermsAndConditions = () => {
    window.open(
      "http://www.bca.co.uk/legal/terms-conditions/ev-battery-grading-terms",
      "_blank"
    );
    pushBatteryGradeData(
      {
        action: "navigate",
        category: "button",
        label: "ev-battery|terms-conditions",
        name: "click",
        section: "pop-up",
        type: "",
        value: "",
      },
      analyticsData
    );
  };

  const handleMoreOnEvBatteryGrading = () => {
    pushBatteryGradeData(
      {
        action: "navigate",
        category: "link",
        label: "ev-battery|more-info ",
        name: "click",
        section: "pop-up",
        type: "",
        value: "",
      },
      analyticsData
    );
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      open={isOpen}
      placement="right"
      width={598}
      shouldCloseOnBlur={false}
    >
      <Modal.CloseBar onCloseClick={onClose}></Modal.CloseBar>
      <Modal.Header>
        <Typography variant="h5" color="fg_dark_3">
          BCA EV Battery Health Grading
        </Typography>
      </Modal.Header>
      <Modal.Body display="flex" flexDirection="column" gap="xl">
        <Typography variant="body-large" color="fg_dark_3">
          A comprehensive analysis of the functionality of the HV / traction
          battery. Various areas of the battery are tested and our health score
          is produced.
        </Typography>
        <BatteryGradesTable batteryGrade={data?.condition} />
        <Box display="flex" flexDirection="column" gap="md">
          <Typography variant="h6" color="fg_dark_3">
            Detailed report
          </Typography>
          <Typography variant="body-large" color="fg_dark_3">
            The AVILOO Flash Test generates a detailed report that provides the
            basis for our health score. This can be viewed, downloaded and
            shared with your buyers.
          </Typography>
          <Typography variant="body-large" color="fg_dark_3">
            * The grading and test results in this report are provided for
            information and are NOT eligible to be claimed on.
          </Typography>
          <Link
            inline={false}
            href="http://www.bca.co.uk/buy/ev-battery-grading"
            target="_blank"
            onClick={handleMoreOnEvBatteryGrading}
          >
            More on BCA EV Battery Health Grading
          </Link>
        </Box>
      </Modal.Body>
      <Modal.Actions gap="lg">
        <Button
          text="Terms and Conditions"
          variant="secondary"
          onClick={handleTermsAndConditions}
        />
        <Button
          disabled={!Boolean(data.reportUrl)}
          text="View report"
          onClick={handleViewReport}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default BatteryGradeSlideout;
